import { useNavigate } from "react-router-dom";
import { guides } from "./methodology-registry";
import { cn } from "@/lib/utils";

export function GuidesPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-svh -mx-6 -my-8 px-6 py-6 sm:py-8 bg-stone-50">
      <div className="mx-auto max-w-5xl">
        <header className="mb-6">
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-stone-500">
            ספרייה
          </p>
          <h1 className="mt-2 text-3xl sm:text-4xl font-bold tracking-[-0.02em] leading-tight text-stone-900">
            מדריכים.
          </h1>
          <p className="mt-3 text-base text-stone-600 max-w-xl leading-relaxed">
            תבניות מפגש, תסריטים והרהורי מאמנת.
          </p>
        </header>

        {guides.length === 0 ? (
          <div className="rounded-[28px] bg-stone-200 px-8 py-16 text-center">
            <p className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-900">
              עוד אין מדריכים.
            </p>
          </div>
        ) : (
          <div className="rounded-[24px] bg-white overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-[11px] font-semibold uppercase tracking-[0.18em] text-stone-500">
                  <th className="px-6 py-4 text-right font-semibold tabular-nums w-16">
                    #
                  </th>
                  <th className="px-6 py-4 text-right font-semibold">כותרת</th>
                </tr>
              </thead>
              <tbody>
                {guides.map((g, idx) => (
                  <tr
                    key={g.path}
                    onClick={() => navigate(g.path)}
                    className={cn(
                      "border-t border-stone-200/70 cursor-pointer",
                      "hover:bg-stone-50 transition-colors",
                    )}
                  >
                    <td className="px-6 py-4 align-middle font-bold tabular-nums text-stone-900">
                      {String(idx + 1).padStart(2, "0")}
                    </td>
                    <td className="px-6 py-4 align-middle">
                      <span className="text-base font-semibold text-stone-900 tracking-tight">
                        {g.label}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
